<section class="breadcrumb-banner">
  <div class="container">
    <div class="row">
      <div class="col-md-12 col-lg-12">
        <div class="breadcrumb-text">
          <h1>
          5th Nagpur Below 1700 FIDE Rating Chess Tournament
          </h1>
        </div>
      </div>
    </div>
  </div>
  <div class="breadcrumb-bottom-img">
    <img
      src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"
    />
  </div>
</section>
<section class="section section-sm fide-chesscompetition section-banner-bg-1">
  <div class="container">
    <!-- <div class="sec-title text-center mb-5">
      <h2>
        <span
          >5th Nagpur Below 1700 FIDE Rating Chess Tournament</span
        >
      </h2>
    </div> -->
    <div class="row justify-content-between">
      <div class="col-md-12">
      <p>The 5th Nagpur Below 1700 FIDE Rating Chess Tournament was inaugurated on 15th August 2025 at G.H. Raisoni Institute, Wadi.</p>

      <h5>Inaugural Ceremony Highlights:</h5>

      <ul class="list-style list-style1 mb-3">
        <li>Chief Guest: Shri Jaiprakash Gupta</li>

        <li>Guest of Honour: CA Sudhir Dabir</li>
                <li>Dignitaries Present: Shri Kunal Shukul, Shri Himanshu Sharma (Dean, GH Raisoni), and Organising Secretary Shri Bhushan Shriwas.</li>
        </ul>



        <p>The event is jointly organised by Kalpana Prakash Welfare Foundation, G.H. Raisoni Sports & Cultural Foundation, and SG Reality.</p>

        <h5>Tournament Facts:</h5>

        <p>Record 617 players, including 264 rated participants</p>

          <ul class="list-style list-style1 mb-3">
            <li>Prize Fund: ₹3,00,000</li>
            <li>Duration: 15th – 17th August 2025</li>
          </ul>
          <p>Recognised by CAN, MCA, AICF, and FIDE</p>
      </div>
      <div class="col-md-12">
        <div class="sec-title mt-4 text-center">
          <h2><span>Media Coverage</span></h2>
        </div>
        <div class="lightBox--gallery">
          <ul class="list-unstyled lightgallery justify-content-center row row-cols-1 row-cols-md-4">

            <li
              class="col"
              data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ngp-1700-fide-rating-chess-tournament.webp"
              data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ngp-1700-fide-rating-chess-tournament.webp"
            >
              <a href="Javascript:void(0);">
                <img
                  src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ngp-1700-fide-rating-chess-tournament.webp"
                  alt="GHRSCF"
                  title="GHRSCF"
                  class="img-fluid"
                />
                <div class="light-gallery-poster">
                  <img
                    src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                  />
                </div>
              </a>
            </li>
            <li
              class="col"
              data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ngp-1700-fide-rating-chess-tournament1.webp"
              data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ngp-1700-fide-rating-chess-tournament1.webp"
            >
              <a href="Javascript:void(0);">
                <img
                  src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ngp-1700-fide-rating-chess-tournament1.webp"
                  alt="GHRSCF"
                  title="GHRSCF"
                  class="img-fluid"
                />
                <div class="light-gallery-poster">
                  <img
                    src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                  />
                </div>
              </a>
            </li>

            <li
              class="col"
              data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ngp-1700-fide-rating-chess-tournament2.webp"
              data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ngp-1700-fide-rating-chess-tournament2.webp"
            >
              <a href="Javascript:void(0);">
                <img
                  src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ngp-1700-fide-rating-chess-tournament2.webp"
                  alt="GHRSCF"
                  title="GHRSCF"
                  class="img-fluid"
                />
                <div class="light-gallery-poster">
                  <img
                    src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                  />
                </div>
              </a>
            </li>
            <li
              class="col"
              data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ngp-1700-fide-rating-chess-tournament3.webp"
              data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ngp-1700-fide-rating-chess-tournament3.webp"
            >
              <a href="Javascript:void(0);">
                <img
                  src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ngp-1700-fide-rating-chess-tournament3.webp"
                  alt="GHRSCF"
                  title="GHRSCF"
                  class="img-fluid"
                />
                <div class="light-gallery-poster">
                  <img
                    src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                  />
                </div>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>
